import React , { useState, useEffect } from 'react';
import Layout from '../../../Layout/Lighttheme';
import {ProductdetailV1} from "../../../ProductDetail";
import { useLocation } from '@reach/router';
import {getProductDetail, getProductByCategories, getCategories, getBrands} from "../../../../service/myProductService";
import {BrandsV1} from '../../../Brand';
import { pushtracking } from '../../../../service/trackingService';
import Category from '../../../Categories/Category';

const Product =()=> {
 
  const location = useLocation();
  let uri = location.pathname?.replace('.html','').replace('/','');
  const [defaullink, setDefaullink] = useState();
  const [pageType, setPageType] = useState('');
  var [dataDetail, setdataDetail] = useState([]);
  const loadProduct =()=>{
    try{
      window.localStorage.setItem('gotohome', true);
      getProductDetail(location.pathname).then((response) => {
        if(+response.status === 426){
          // window.location.href = '/404.html';
          window.location.href = location.origin;
        }
        if(response.status !== 426 || response.status !== 500 || response.status !== 404){
          if(response.message !== "Không tìm thấy thông tin sản phẩm!" ){
            setdataDetail(response["message"]);
            window.localStorage.setItem('sku', response["message"].sku);
            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({ ecommerce: null });
            window.dataLayer.push({
                    'event': 'view_item',
                    'ecommerce': {
                      'currency': "VND",
                      'value': +response["message"]?.price?.import,
                        'items': [
                          {
                            item_id: response["message"]?.sku,
                            item_name: response["message"]?.name,
                            price: +response["message"]?.price?.import
                          }
                        ]
                    }
                });
            try{
                  pushtracking(window.localStorage.getItem('sessionId')??null,
                  window.localStorage.getItem('_id')??null,
                  window.localStorage.getItem('phone')??null ,
                  location.pathname, "Chi tiết sản phẩm", 0,0,'index','inWeb',[response.message?.sku],'Website PC').then((response)=>{
                      console.log('send tracking');
                  });
            }catch(e){console.log(e)}
            setPageType("product");    
          }else{
            setPageType(""); 
            setdataDetail("Không tìm thấy thông tin sản phẩm!");
          }    
        }else{
          // window.location.href = '/404.html';
          window.location.href = location.origin;
        }
    }); 
    }catch(e){console.log(e);}
  }
  const [loadMoreStart, setLoadMoreStart] = useState(0);
  const [totalPage, setTotalPage] = useState(0);
  const [categoryCate, setCategoryCate] = useState([]);
  const [Brand, setBrand] = useState([]);
  const getDataCategories= async()=>{
    await getCategories().then((response)=>{
        if(+response.status === 200){
            var _uri_cate = [];
            response.message?.forEach(element => {
                _uri_cate.push(element.url_key);
                if(element.child?.length > 0){
                    element.child?.forEach(element1 => {
                        _uri_cate.push(element1.url_key);
                        if(element1.child.length > 0){
                            element1.child?.forEach(element2 => {
                                _uri_cate.push(element2.url_key);
                            });
                        }
                    });
                }
            });
            setCategoryCate(_uri_cate)
        }
    });
  }
  const loadDataBrand=async()=>{
    await getBrands().then((response)=>{
        if(+response.status === 200){
            var _uri_brand = [];
            response.message?.forEach(element => {
                _uri_brand.push(element.url_key);
            });
            setBrand(_uri_brand);
        }
    });
  }


  useEffect(()=>{
    if(uri.includes('undefined')){
      window.history.back();
    }
    async function fetchData() {
      await getDataCategories();
      await loadDataBrand();
      if(!categoryCate.includes(uri) && !Brand.includes(uri)){
        loadProduct();
      }
    }
    fetchData();
    setDefaullink(window.localStorage.getItem('typepage'));
    setPageType("");  
      setPageType('');
      setTotalPage(0);
      setLoadMoreStart(1);
      
    },[]);

  if(categoryCate.length > 0 && Brand.length > 0){
    return (
      <Layout>
        {
         categoryCate.includes(uri) !== true && Brand.includes(uri) !== true ? (
            <ProductdetailV1 item={dataDetail} key="productdetail"/>
          ):(null)
          
        }
        {
           categoryCate.includes(uri) === true ? (
            <Category/>
          ):(null)
        }

        {
           Brand.includes(uri) === true ? (
            <BrandsV1/>
          ):(null)
        }

      </Layout>
    )  
  }else{
    return <Layout>
      <div id="landing-web">
        <div className="loading-page"  style={{textAlign:"center"}}>
            <img src="/../images/loading.gif" alt="icon"/>
        </div>
      </div>
    </Layout>;
  }
    
}
export default Product;



